import React, { ButtonHTMLAttributes } from 'react'
import "./Button.scss"

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  btnText?: string;
  className?: string;
  isProductPage?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
const { btnText, className = "", isProductPage = false, ...rest } = props;
  
 const renderText = () => {
  if (!btnText) return null;
  const parts = String(btnText).split('\n');
  return parts.map((part, index) => (
    <React.Fragment key={index}>
      {isProductPage && index === 0 ? <p className="button-text-ownit">{part}</p> : part}
    
    </React.Fragment>
  ));
};

  return (
    <button className={`btn primary-btn ${className}`} ref={ref} {...rest}>
      {renderText()}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;